import * as React from "react";
import { useRef, useState } from "react";
import { useFloating } from "@floating-ui/react";
import OnClickPopoverWrapper from "views/components/visualizations/OnClickPopover/OnClickPopoverWrapper";
const alignByRelativeCoords = (rel = { x: 0, y: 0 }) => ({
  name: "alignByRelativeCoords",
  options: rel,
  fn: ({ x, y, rects }) => ({
    x: x + rects.reference.width * rel.x,
    y: y + rects.reference.height * rel.y
  })
});
const usePlotOnClickPopover = ({ buildAnchor, renderPopover, config }) => {
  const gdRef = useRef(null);
  const [anchor, setAnchor] = useState(null);
  const { refs, floatingStyles } = useFloating({
    placement: "top-start",
    elements: {
      reference: anchor == null ? void 0 : anchor.el
    },
    transform: false,
    middleware: [alignByRelativeCoords(anchor == null ? void 0 : anchor.rel)]
  });
  const initializeGraphDivRef = (_, gd) => {
    gdRef.current = gd;
  };
  const onPopoverClose = () => setAnchor(null);
  const onChartClick = (_, e) => {
    var _a, _b;
    const targetEl = (_a = e.event) == null ? void 0 : _a.target;
    const targetElForClosest = targetEl instanceof Element ? targetEl : null;
    const gd = (_b = gdRef.current) != null ? _b : targetElForClosest == null ? void 0 : targetElForClosest.closest(".js-plotly-plot");
    if (!gd) return;
    const a = buildAnchor(e, gd);
    if (!a) return;
    setAnchor((prev) => {
      if (prev && prev.el === a.el) return prev;
      return a;
    });
  };
  const onPopoverChange = (isOpen) => {
    if (!isOpen) onPopoverClose();
  };
  const isPopoverOpen = !!anchor;
  const popover = /* @__PURE__ */ React.createElement(
    OnClickPopoverWrapper,
    {
      isPopoverOpen,
      onPopoverChange,
      ref: refs.setFloating,
      style: floatingStyles
    },
    anchor ? renderPopover({ anchor, config, onPopoverClose }) : null
  );
  return { initializeGraphDivRef, onChartClick, popover };
};
export default usePlotOnClickPopover;
